import type { PluginExports } from 'graylog-web-plugin/plugin';

import AssocAsssetsWidget from './AssocAssetsWidget';

const assetsExports: PluginExports = {
  'views.components.assetInformationActions': [{ component: AssocAsssetsWidget, key: 'assets' }],
};

export default assetsExports;
